import Crud from '../views/VehicleColor/Crud'
import Entity from '../views/VehicleColor/Add'

let routes = {
    path: '/vehicle_colors',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/vehicle_colors/add',
            name: 'NewVehicleColor',
            component: Entity,
            meta: {
                pageTitle: 'Vehicle Colors',
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to:'/vehicle_colors'
                    },
                    {
                        text: 'Add',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/vehicle_colors/edit/:id?',
            name: 'EditVehicleColor',
            component: Entity,
            meta: {
                pageTitle: 'Vehicle Colors',
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to:'/vehicle_colors'
                    },
                    {
                        text: 'Edit',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/vehicle_colors',
            name: 'list-vehicle_colors',
            component: Crud,
            meta: {
                pageTitle: 'Vehicle Colors',
                breadcrumb: [
                    {
                        text: 'List',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
